import { FgBlockType } from '../../block-type.js';
import { FgType } from '../../types.js';
import { getDataValue, setDataValue } from '../../runtime.js';
import { sockOut, sockIn } from '../../sockets.js';
import { isFgInt } from '../../custom-types/fg-integer.js';

const intToFloatDef = {
  type: FgBlockType.IntToFloat,
  build: () => ({
    dataIn: [sockIn("a", FgType.Integer)],
    dataOut: [sockOut("value", FgType.Number)]
  }),
  updateOutputs(block, ctx, env) {
    const a = getDataValue(ctx, env, block, "a");
    setDataValue(ctx, block, "value", isFgInt(a) ? a.value : a);
  }
};

export { intToFloatDef };
//# sourceMappingURL=int-to-float.js.map
